"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileStore = void 0;
const services_1 = require("../services");
class UserProfileStore {
    get(userId) {
        const rest = services_1.Services.Department.rest;
        return rest.Department.User.getProfileById(userId).value;
    }
}
exports.UserProfileStore = UserProfileStore;
//# sourceMappingURL=user.profile.store.js.map